import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22154ce1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "company-wide", -1))
const _hoisted_5 = {
  key: 0,
  class: "goal-input"
}
const _hoisted_6 = {
  key: 1,
  class: "goal-input"
}
const _hoisted_7 = {
  key: 2,
  class: "goal-input"
}
const _hoisted_8 = { class: "footer" }

import { computed, onMounted, ref, watch } from 'vue'
import type { Ref } from 'vue'
import { defineRule, useField } from 'vee-validate'
import { between, required } from '@vee-validate/rules'
import { ModalSize } from '@/components/modal-size'
import Modal from '@/components/Modal.vue'
import Typography from '@/components/Rain/Typography/Typography.vue'
import PortalContainer from '@/mobile/src/components/containers/PortalContainer.vue'
import BaseButton from '@/components/BaseButton.vue'
import Loading from '@/components/Loading.vue'
import { getCompanyFields, setCompanyConfig } from '@/api/company'
import { CompanyAttributes, ICompanyConfig } from '@/entities'
import { countDecimals } from '@/utils/number'
import store from '@/mobile/src/store/index'

interface Props {
    show: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyGoalsModal',
  props: {
    show: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

defineRule('between', between)
defineRule('required', required)
defineRule('maxDecimals', (value, [quantity]) => {
    return countDecimals(value) <= quantity
})

const props = __props
const emit = __emit

const companyVars = computed(() => store.getters['$companyVars'])
const hasMultiMetric = computed(
    () => companyVars.value.has_lead_with_any_question
)
const isNpsTargetEnabled = computed(() => companyTargets.value?.target_enabled)
const isCsatTargetEnabled = computed(
    () => companyTargets.value?.target_csat_enabled && hasMultiMetric
)
const isFiveStarTargetEnabled = computed(
    () => companyTargets.value?.target_fivestar_enabled && hasMultiMetric
)

const companyTargets: Ref<ICompanyConfig> = ref({})
const loading = ref(false)
const errorOnSave = ref(false)
const hasValidationErrors = ref(true)

const npsTarget = useField<string>('NPS Goal', {
    between: [-100, 100],
    maxDecimals: 0,
    required: true,
})
const fiveStarTarget = useField<string>('Five Star Goal', {
    between: [0, 5],
    maxDecimals: 1,
    required: true,
})
const csatTarget = useField<string>('CSAT Goal', {
    between: [0, 5],
    maxDecimals: 1,
    required: true,
})

watch(npsTarget.errors, () => {
    if (hasMultiMetric.value) {
        hasValidationErrors.value =
            npsTarget.errors.value.length > 0 ||
            fiveStarTarget.errors.value.length > 0 ||
            csatTarget.errors.value.length > 0
    } else {
        hasValidationErrors.value = npsTarget.errors.value.length > 0
    }
})

watch(fiveStarTarget.errors, () => {
    if (hasMultiMetric.value) {
        hasValidationErrors.value =
            npsTarget.errors.value.length > 0 ||
            fiveStarTarget.errors.value.length > 0 ||
            csatTarget.errors.value.length > 0
    }
})

watch(csatTarget.errors, () => {
    if (hasMultiMetric.value) {
        hasValidationErrors.value =
            npsTarget.errors.value.length > 0 ||
            fiveStarTarget.errors.value.length > 0 ||
            csatTarget.errors.value.length > 0
    }
})

onMounted(async () => {
    let fieldsToFetch: CompanyAttributes[] = []
    const enabledTargets = hasMultiMetric.value
        ? ['target', 'target_csat', 'target_fivestar']
        : ['target']

    enabledTargets.forEach((targetType) => {
        fieldsToFetch.push(CompanyAttributes[targetType])
        fieldsToFetch.push(CompanyAttributes[targetType + '_enabled'])
    })

    loading.value = true
    const { data } = await getCompanyFields(fieldsToFetch)

    companyTargets.value = data
    npsTarget.setValue(data.target)
    fiveStarTarget.value.value = data.target_fivestar
    csatTarget.value.value = data.target_csat
    loading.value = false
})

const saveTargets = async () => {
    if (!hasValidationErrors.value) {
        const { data } = await setCompanyConfig({
            ...companyTargets.value,
            target: npsTarget.value.value,
            target_fivestar: fiveStarTarget.value.value,
            target_csat: csatTarget.value.value,
        })

        if (data.success) {
            emit('close')
        } else {
            errorOnSave.value = true
        }
    }
}

const handleClose = () => {
    emit('close')
}

return (_ctx: any,_cache: any) => {
  return (props.show)
    ? (_openBlock(), _createBlock(PortalContainer, {
        key: 0,
        onBack: handleClose
      }, {
        default: _withCtx(() => [
          _createVNode(Modal, {
            show: props.show,
            size: _unref(ModalSize).Full,
            "has-close": true,
            close: handleClose,
            "small-header": true,
            padding: 25
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                (loading.value)
                  ? (_openBlock(), _createBlock(Loading, {
                      key: 0,
                      loading: loading.value,
                      contained: true
                    }, null, 8, ["loading"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", {
                        class: "close",
                        onClick: handleClose
                      }, "×"),
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(Typography, { variant: "subtitle1" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Company Goals")
                          ], undefined, true),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(Typography, { variant: "body1" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Any change affects the "),
                            _hoisted_4,
                            _createTextVNode(" goal.")
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(Typography, { variant: "body2" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Make sure you have permission to change this")
                          ], undefined, true),
                          _: 1
                        }),
                        (isNpsTargetEnabled.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createVNode(Typography, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("NPS Goal")
                                ], undefined, true),
                                _: 1
                              }),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(npsTarget).value.value) = $event)),
                                type: "number",
                                min: "-100",
                                max: "100",
                                step: "1"
                              }, null, 512), [
                                [_vModelText, _unref(npsTarget).value.value]
                              ]),
                              (_unref(npsTarget).errors.value.length > 0)
                                ? (_openBlock(), _createBlock(Typography, {
                                    key: 0,
                                    variant: "body2",
                                    class: "error"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Goal must be between -100 and 100")
                                    ], undefined, true),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (isCsatTargetEnabled.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _createVNode(Typography, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("CSAT Goal")
                                ], undefined, true),
                                _: 1
                              }),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(csatTarget).value.value) = $event)),
                                type: "number",
                                min: "0",
                                max: "5.0",
                                step: "0.1"
                              }, null, 512), [
                                [_vModelText, _unref(csatTarget).value.value]
                              ]),
                              (_unref(csatTarget).errors.value.length > 0)
                                ? (_openBlock(), _createBlock(Typography, {
                                    key: 0,
                                    variant: "body2",
                                    class: "error"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Goal must be between 0 and 5.0")
                                    ], undefined, true),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (isFiveStarTargetEnabled.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createVNode(Typography, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Five Star Goal")
                                ], undefined, true),
                                _: 1
                              }),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(fiveStarTarget).value.value) = $event)),
                                type: "number",
                                min: "0",
                                max: "5.0",
                                step: "0.1"
                              }, null, 512), [
                                [_vModelText, _unref(fiveStarTarget).value.value]
                              ]),
                              (_unref(fiveStarTarget).errors.value.length > 0)
                                ? (_openBlock(), _createBlock(Typography, {
                                    key: 0,
                                    variant: "body2",
                                    class: "error"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Goal must be between 0 and 5.0")
                                    ], undefined, true),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (errorOnSave.value)
                          ? (_openBlock(), _createBlock(Typography, {
                              key: 3,
                              variant: "body2",
                              class: "error"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Failed to save, please try again.")
                              ], undefined, true),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(BaseButton, {
                          full: true,
                          centred: true,
                          class: "purple outline",
                          click: handleClose
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Cancel ")
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(BaseButton, {
                          disabled: hasValidationErrors.value,
                          full: true,
                          centred: true,
                          class: "purple",
                          click: saveTargets
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Update ")
                          ], undefined, true),
                          _: 1
                        }, 8, ["disabled"])
                      ])
                    ], 64))
              ])
            ], undefined, true),
            _: 1
          }, 8, ["show", "size"])
        ], undefined, true),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})